import { ReactElement, ReactNode } from 'react';
import styles from './CustomTextUnderlineDecoration.module.scss';

interface ICustomTextUnderlineDecoration {
  children: ReactNode;
}

const CustomTextUnderlineDecoration = ({
  children,
}: ICustomTextUnderlineDecoration): ReactElement => (
  <div className={styles.root}>{children}</div>
);

export default CustomTextUnderlineDecoration;
